export const img_upload_base_path = `https://${
  import.meta.env.VITE_S3_BUCKET
}.s3.${import.meta.env.VITE_AWS_REGION || "us-west-1"}.amazonaws.com/public/`

/** In dev, same-origin path is proxied by Vite to execute-api (avoids browser cross-origin failures). */
export const GET_SIGNED_URL = import.meta.env.DEV
  ? '/internal/file/put-signed-url'
  : import.meta.env.VITE_GET_SIGNED_URL

export const mesh_upload_base_path = `https://${
  import.meta.env.VITE_S3_BUCKET_FOR_MESH
}.s3.${import.meta.env.VITE_AWS_REGION || "us-west-1"}.amazonaws.com/public/`

export const GET_SIGNED_URL_MESH = import.meta.env.DEV
  ? '/internal/file/put-signed-url'
  : import.meta.env.VITE_GET_SIGNED_URL_FOR_MESH

/** Base path for the REST file API (list, batch-urls, folder). Dev goes through the Vite /internal proxy. */
export const FILE_API_BASE = import.meta.env.DEV
  ? '/internal/file'
  : import.meta.env.VITE_FILE_API_URL